/**
 * 服务端渲染时把已经拿到的数据交给页面组件，浏览器水合时再从 window.__DATA__ 里读同一份，
 * 两边渲染出一样的 HTML。没有这份数据（纯客户端渲染）时，页面自己 fetch。
 */
import { createContext, useContext } from "react";
import type { Product } from "./data/products.ts";
import type { Review } from "./api.ts";

export interface InitialData { products?: Product[]; reviews?: Record<string, Review[]> }
export const InitialDataContext = createContext<InitialData>({});
export const useInitialData = () => useContext(InitialDataContext);
